import React from "react";
import { Navigate } from "react-router-dom";
import useAuth from "../hooks/useAuth";

const PublicRoute = ({ children }) => {
  
  const { customer } = useAuth();

  return !customer?.email ? children : <Navigate to="/" />;
};

export default PublicRoute;
